export default "__VITE_ASSET__CAR6UGUC__"